// extracted by css-extract-rspack-plugin
export default {"cls1":"PaywallPage-cls1_4zs","cls2":"PaywallPage-cls2_tIN PaywallPage-cls1_4zs"};